module.exports = __webpack_public_path__ + "static/img/cabinet12_3.ffd4b89a.gif";